export default "__VITE_ASSET__cb153b27__"